import { useChapterSettings } from '@app/components/chapters/hooks';
import { useAuth } from '@app/libs/auth';
import { useLocation } from 'react-router-dom';

export const useCommentsUrlHash = (paragraphId?: string | undefined | null) => {
    const { user } = useAuth();
    const [settings] = useChapterSettings();

    //if paragraph comments is disabled everywhere, force open it in paragraph comment model
    const isParaCommentEnabled = settings.paragraphComments || !(user?.settings?.isParagraphCommentsEnabled ?? false);

    const location = useLocation();
    const hash = location.hash;

    const hashSplit = hash.substring(1).split('~');

    const hashCommentId = hashSplit.length > 0 ? hashSplit[0] : '';
    const commentId = hashCommentId.length > 0 && Number.isInteger(+hashCommentId) ? Number(hashCommentId) : undefined;

    const hashParaId = !isParaCommentEnabled ? undefined : hashSplit.length > 1 ? hashSplit[1] : undefined;
    const paraId = hashCommentId.length > 0 && (hashParaId?.length ?? 0) > 0 ? hashParaId : undefined;

    const commentBelongsToCurrentPara = !!commentId && paragraphId === hashParaId;

    return {
        pathname: location.pathname,
        search: location.search,
        state: location.state,
        hash: hash,
        hashCommentId: commentId,
        hashParaId: paraId,
        showHashCommentInThisPara: commentBelongsToCurrentPara,
    };
};
